import axios from 'axios'
import {getTemplateImageUrl} from 'utils/templateImageUrl'

const blobToDataUrl = (blob: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })

const fetchImageBlob = async (imagePath: string): Promise<Blob> => {
  const url = getTemplateImageUrl(imagePath)
  try {
    const response = await axios.get(url, {responseType: 'blob'})
    if (response.status !== 200 || !response.data?.size) {
      throw new Error(`No se pudo cargar la imagen (${response.status})`)
    }
    return response.data
  } catch (err: unknown) {
    const axiosErr = err as {response?: {status?: number}; message?: string}
    const status = axiosErr.response?.status
    let detail: string
    if (status === 400) {
      detail = `Ruta de archivo inválida: ${imagePath}`
    } else if (status === 404) {
      detail = `Archivo no encontrado: ${imagePath}`
    } else if (status) {
      detail = `Error ${status} al pedir ${url}`
    } else {
      detail = axiosErr.message || 'Error de red'
    }
    const serverHint =
      !status || status >= 500
        ? ' Verificá que certificados-loopback esté corriendo y tenga GET /files.'
        : ''
    throw new Error(`${detail}.${serverHint}`)
  }
}

/** Imagen lista para react-pdf (data URL base64). */
const fetchImageDataUrl = async (imagePath: string): Promise<string> => {
  const blob = await fetchImageBlob(imagePath)
  return blobToDataUrl(blob)
}

const exportedMethods = {
  fetchImageBlob,
  fetchImageDataUrl,
  getTemplateImageUrl,
}

export default exportedMethods
